<mat-form-field appearance="outline">
    <mat-icon matPrefix>search</mat-icon>
    <input
        matInput
        [formControl]="searchInput"
        class="search-input"
        [placeholder]="(label ? label : 'GENERAL.SEARCH') | translate"
        (blur)="trimSearchValue()"
        (keydown.enter)="trimSearchValue()"
    />

    <button matSuffix mat-icon-button aria-label="Clear" *ngIf="searchInput.value" (click)="$event.preventDefault(); $event.stopPropagation(); searchInput.setValue('')">
        <mat-icon>close</mat-icon>
    </button>
</mat-form-field>
